class Triggerable {
  constructor(group, value, callback) {
    this.group = group
    this.value = value
    this.callback = callback
    this.triggered = false
  }

  trigger() {
    if (!this.triggered) {
      this.runTrigger()
      this.triggered = true
    }
  }
}

class Callback extends Triggerable {
  runTrigger() {
    this.value()
  }
}

class Script extends Triggerable {
  runTrigger() {
    const newScript = document.createElement('script')
    newScript.setAttribute('src', this.value)
    if (this.callback) {
      newScript.onload = this.callback
    }
    document.head.appendChild(newScript)
  }
}

class AsyncScript extends Triggerable {
  runTrigger() {
    const newScript = document.createElement('script')
    newScript.setAttribute('src', this.value)
    newScript.setAttribute('async', 'true')
    if (this.callback) {
      newScript.onload = this.callback
    }
    document.head.appendChild(newScript)
  }
}

class CookieConsent {
  constructor() {
    this.triggerables = []
    this.wrapperFired = false
  }

  initBrowser() {
    if (CookieConsent.optanonPresent()) {
      window.OptanonWrapper = this.optanonWrapper.bind(this)
    } else {
      this.optanonWrapper()
    }
  }

  optanonWrapper() {
    this.triggerAll()
    this.wrapperFired = true
  }

  addScript(group, script, callback) {
    this.addTriggerable(new Script(group, script, callback))
  }

  addAsyncScript(group, script, callback) {
    this.addTriggerable(new AsyncScript(group, script, callback))
  }

  addCallback(group, callback) {
    this.addTriggerable(new Callback(group, callback))
  }

  addTriggerable(triggerable) {
    this.triggerables.push(triggerable)

    if (this.wrapperFired) {
      CookieConsent.trigger(triggerable)
    }
  }

  triggerAll() {
    this.triggerables.forEach((triggerable) => {
      CookieConsent.trigger(triggerable)
    })
  }

  static trigger(triggerable) {
    if (CookieConsent.groupActive(triggerable.group)) {
      triggerable.trigger()
    }
  }

  static groupActive(group) {
    if (CookieConsent.optanonPresent()) {
      const groupMatcher = new RegExp(`,(${CookieConsent.groupId(group)}|${CookieConsent.legacyGroupId(group)}),`)
      return (window.OptanonActiveGroups.match(groupMatcher))
    }

    return true
  }

  static optanonPresent() {
    return (typeof window.Optanon !== 'undefined')
  }

  static groupId(group) {
    switch (group) {
      case 'necessary':
      case 'C0001':
      case 1:
        return 'C0001'
      case 'performance':
      case 'C0002':
      case 2:
        return 'C0002'
      case 'functional':
      case 'C0003':
      case 3:
        return 'C0003'
      case 'targeting':
      case 'C0004':
      case 4:
        return 'C0004'
      default:
        return 'C0001'
    }
  }

  static legacyGroupId(group) {
    switch (group) {
      case 'necessary':
      case 'C0001':
      case 1:
        return 1
      case 'performance':
      case 'C0002':
      case 2:
        return 2
      case 'functional':
      case 'C0003':
      case 3:
        return 3
      case 'targeting':
      case 'C0004':
      case 4:
        return 4
      default:
        return 1
    }
  }
}

export default CookieConsent
